import React from 'react'
import { TextFieldProps } from '@mui/material'
import CustomTextField from './CustomTextField'
import { ChampDansFormulaire } from './types/typePourChampDansFormulaireModel'
import { fontFamilyMonserrat } from '../../theme'
import ErrorComponent from './ErrorComponent'

export interface TextFieldAcceptingProps {
	id: string
	maxLength?: number
}

type FormTextFieldProps = ChampDansFormulaire & TextFieldAcceptingProps & TextFieldProps

const FormTextField = (
	{
		id,
		label,
		placeholder,
		multiline,
		maxLength,
		rows = 5,
		register,
		inputProps,
		errors,
		sx
	}: FormTextFieldProps
) => {
	return (
		<>
			{
				label && (
					<span
						style={{
							width: '100%',
							paddingRight: 15,
							paddingTop: 7,
							fontSize: 14,
							marginBottom: 5,
							marginLeft: 0,
							boxSizing: 'border-box',
							textAlign: 'left',
							fontFamily: fontFamilyMonserrat,
							fontWeight: 500
						}}
					>
						{label}
					</span>
				)
			}

			<CustomTextField
				sx={sx}
				id={id}
				multiline={multiline}
				rows={rows}
				maxLength={maxLength}
				placeholder={placeholder}
				register={register}
				inputProps={{ ...inputProps }}
			/>

		</>
	)
}

export default FormTextField
